import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, fmt, errMsg } from "../../lib/api";

export default function AdminProduction() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  const [notice, setNotice] = useState({ ok: false, msg: "" });

  async function load() { const r = await api.get("/admin/production"); setRows(r.data); }
  useEffect(() => { load().catch(() => {}); }, []);

  async function runCron() {
    setNotice({ ok: false, msg: "" });
    try {
      const r = await api.post("/admin/cron/daily-production");
      setNotice({ ok: true, msg: `Bugün için ${r.data.credited} aktif pakete üretim yatırıldı.` });
      load();
    } catch (e) { setNotice({ ok: false, msg: errMsg(e) }); }
  }

  const total = rows.reduce((s, r) => s + Number(r.amount || 0), 0);
  return (
    <AdminLayout user={user} active="Üretimler">
      <section className="admin-panel">
        <div className="admin-panel-title">
          <div><span className="eyebrow">GÜNLÜK ÜRETİM</span><h2>Toplam ${fmt(total)}</h2></div>
          <button className="btn btn-accent" onClick={runCron} data-testid="admin-run-cron">Bugünkü Üretimi Çalıştır</button>
        </div>
        {notice.msg && <div className={notice.ok ? "success" : "error"}>{notice.msg}</div>}
        <div className="table-wrap">
          <table>
            <thead><tr><th>Tarih</th><th>Kullanıcı</th><th>Tutar</th><th>Referans</th><th>Durum</th></tr></thead>
            <tbody>
              {rows.map((t, i) => (
                <tr key={i} data-testid={`admin-prod-row-${i}`}>
                  <td>{new Date(t.date).toLocaleString("tr-TR")}</td>
                  <td className="hash">{(t.user_id || "").slice(0, 10)}…</td>
                  <td>${fmt(t.amount)}</td>
                  <td className="hash">{(t.reference || "").slice(0, 12)}</td>
                  <td><span className="status confirmed">{t.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!rows.length && <div className="table-empty">Üretim kaydı yok.</div>}
        </div>
      </section>
    </AdminLayout>
  );
}
